// extracted by mini-css-extract-plugin
module.exports = {"priceLabel":"styles_priceLabel__ys7S7","priceLabelText":"styles_priceLabelText__fWiue"};